import { ThemeEvents } from '@theme/events';

/**
 * PDP の Paidy 分割払いウィジェット（#331）。
 *
 * 分割金額はバリアントの価格で変わるので、バリアント切り替え時に `data-amount` を差し替える。
 * 金額の計算は Liquid 側（`blocks/paidy-widget-yokomo.liquid`）が持っていて、
 * ここは**サーバーが返した新しい HTML から自分の分の `data-amount` を取り出して置き換えるだけ**。
 *
 * Paidy のスクリプトは `._paidy-promotional-messaging` の中に描画するので、
 * 描画済みの中身を消してから `pm:refresh` で描き直させる。
 *
 * 作りは `assets/product-point-yokomo.js` と同じ。variant:update は同じ
 * `.shopify-section` の中でしか拾わないので、別商品のイベントで書き換わることはない。
 */
class PaidyWidgetYokomo extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#updateAmount);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#updateAmount);
  }

  /**
   * @param {CustomEvent} event - variant:update イベント
   */
  #updateAmount = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `paidy-widget-yokomo[data-block-id="${this.dataset.blockId}"]`
    );

    // 新しい価格が0円になった等でブロックごと消えたときは、こちらも消す。
    // 残すと切り替え前の分割金額が出たままになる
    if (!newElement) {
      this.remove();
      return;
    }

    const newWidget = newElement.querySelector('._paidy-promotional-messaging');
    const currentWidget = this.querySelector('._paidy-promotional-messaging');
    if (!newWidget || !currentWidget) return;

    const newAmount = newWidget.getAttribute('data-amount');
    if (newAmount === null || newAmount === currentWidget.getAttribute('data-amount')) return;

    currentWidget.setAttribute('data-amount', newAmount);
    currentWidget.replaceChildren();
    window._paidy?.('pm:refresh');
  };
}

if (!customElements.get('paidy-widget-yokomo')) {
  customElements.define('paidy-widget-yokomo', PaidyWidgetYokomo);
}
